import * as i0 from "@angular/core";
export class ClassCardStore {
}
ClassCardStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ClassCardStore_Factory() { return new ClassCardStore(); }, token: ClassCardStore, providedIn: "root" });
export var ClassCardStoreKeys;
(function (ClassCardStoreKeys) {
})(ClassCardStoreKeys || (ClassCardStoreKeys = {}));
